import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import RootChild from './root';

function Root() {
  return (
    <Router>
      <RootChild />
    </Router>
  );
}

export default Root;
